import { Directive } from '@angular/core';

@Directive({
  selector: '[woTableFilter]',
  standalone: true,
})
export class TableFilterDirective {}
